import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LibCheckMarkComponent } from './check-mark.component';



@NgModule({
  declarations: [
    LibCheckMarkComponent
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    LibCheckMarkComponent
  ]
})
export class LibCheckMarkModule { }
